var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "_component-modal" }, [
    _vm.overlay
      ? _c("div", {
          staticClass: "overlay",
          class: _vm.overlayBgClass,
          on: { click: _vm.handleClickOverlay }
        })
      : _c("div", {
          staticClass: "overlay-trans",
          on: { click: _vm.handleClickOverlay }
        }),
    _c("div", { staticClass: "modal-content" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }